const initialState = {
  purpose_of_loan: '',
  property_type: '',
  no_of_units: '',
  transaction_type: '',
  use_of_funds: '',
  occupancy: '',

  purchase_price: '',
  purchase_date: null,
  as_is_value: '',

  occupancy_at_closing: '',
  suburban_or_rural: '',
  coe_date: null,
  exit_strategy: '',
  exit_repay_loan: '',

  loan_amount: '',
  lien_position: '',
  loan_terms: '',
  interest_rate: '',
  broker_points: '',
  broker_processing_fee_5: '',

  arv_market_value: '',
  rehab_amount: '',
  sq_ft_addition: '',

  purchase_status: '',
  prchs_trnsctn_type: '',
  assignment_fees: '',
  seller_concessions: '',

  property_income: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CONSOLE_BROK1':
      return { ...state, ...action.payload };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/reducer/consoleBrok1.reducer.js